// const baseUrl = 'http://localhost:8651'
// const baseUrl = 'http://zfbhbapi.qinangit.com'//支付宝
// const baseUrl = 'http://ltmcapi.qinangit.com'
// const baseUrl = 'http://mchmapi.qinangit.com'
const baseUrl = 'https://slapi.wantiangong.com'//玩天工
// const baseUrl = 'http://sldemoapi.q/inangit.com'

const url = baseUrl+'/pc'

export default{
	url,
    //首页接口
    apiIndexCount: url + '/index/count',
    //登录接口
    apiStaffPclogin: url + '/staff/pclogin',
    //获取验证码
    apiCaptchaImage: url + '/pc/captchaImage',
	//获取登陆前置参数
	apiGetLoginParm: url + '/staff/getLoginParm',
    
    apiStaffAdd: url + '/staff/add',
    apiStaffQueryList: url + '/staff/queryList',
    apiStaffList: url + '/staff/list',
    apiStaffEdit: url + '/staff/edit',
    apiStaffEditPwd: url + '/staff/editPwd',
    apiStaffAll: url + '/staff/queryAll',
    
    
    //获取菜单
    apiDutyList: url + '/duty/list',
    //根据查询条件获取菜单列表
    apiDutyQueryList: url + '/duty/queryList',
    //添加职责
    apiDutyAdd: url + '/duty/add',
    //修改职责
    apiDutyEdit: url + '/duty/edit',
    //删除职责
    apiDutyDel: url + '/duty/del',
    //获取职责树
    apiDutyTree: url + '/duty/tree',

    //产品分类列表(分页)
    apiProductCategoryQueryList: url + '/product_category/queryList',
    //产品分类列表全部
    apiProductCateList: url + '/product_category/list',
    //添加产品分类
    apiProductCategoryAdd: url + '/product_category/add',
    //修改产品分类
    apiProductCategoryEdit: url + '/product_category/edit',
    //删除产品分类
    apiProductCategoryDel: url + '/product_category/del',

    
    //获取区域列表
    apiRegionList: url + '/region/list',
    
    //根据查询条件获取系统参数列表
    apiSysparmQueryList: url + '/sysparm/queryList',
    //添加系统参数
    apiSysparmAdd: url + '/sysparm/add',
    //修改系统参数
    apiSysparmEdit: url + '/sysparm/edit',
    //删除系统参数
    apiSysparmDel: url + '/sysparm/del',
    //根据参数名称查询参数列表
    apiSysparmListByName: url + '/sysparm/listByName',
    
    //获取服务商列表
    apiFacilitatorList: url + '/facilitator/list',
    //根据查询条件获取服务商列表
    apiFacilitatorQueryList: url + '/facilitator/queryList',
    //添加服务商
    apiFacilitatorAdd: url + '/facilitator/add',
    //修改服务商
    apiFacilitatorEdit: url + '/facilitator/edit',
    //删除服务商
    apiFacilitatorDel: url + '/facilitator/del',

    //获取服务商参数
    apiFacilitatorConfig: url + '/facilitator/config',
    //修改服务商参数
    apiFacilitatorConfigSave: url + '/facilitator/config/save',

	//根据员工id查询所关联的服务商列表
	apiFacilitatorListForStaff: url + '/facilitator/listForStaff',
    //服务商绑定产品分类列表(分页)
    apiProductFacilitatorCategoryQueryList: url + '/product_facilitator_category/queryList',
    //服务商绑定产品分类列表(全部)
    apiProductFacilitatorCategoryList: url + '/product_facilitator_category/list',
    //根据人员ID 获取产品分类列表
    apiProductFacilitatorCategoryListForStaff: url + '/product_facilitator_category/list_by_staff_id',
    //添加服务商绑定产品分类
    apiProductFacilitatorCategoryAdd: url + '/product_facilitator_category/add',
    //删除服务商绑定产品分类
    apiProductFacilitatorCategoryDel: url + '/product_facilitator_category/del',
    
    //获取企业列表
    apiEnterpriseList: url + '/enterprise/list',
    //根据查询条件获取企业列表
    apiEnterpriseQueryList: url + '/enterprise/queryList',
    //添加企业
    apiEnterpriseAdd: url + '/enterprise/add',
    //修改企业
    apiEnterpriseEdit: url + '/enterprise/edit',
    //获取企业绑定服务商列表
    apiEnterpriseFacilitatorQueryList: url + '/enterprise_facilitator/queryList',
    //获取全部企业绑定服务商列表
    apiEnterpriseFacilitatorList: url + '/enterprise_facilitator/list',
    //添加企业绑定服务商
    apiEnterpriseFacilitatorAdd: url + '/enterprise_facilitator/add',
    //删除企业绑定服务商
    apiEnterpriseFacilitatorDel: url + '/enterprise_facilitator/delete',
    
    //获取职位列表
    apiPositionsList: url + '/positions/list',
    //根据查询条件获取职位列表
    apiPositionsQueryList: url + '/positions/queryList',
    //添加职位
    apiPositionsAdd: url + '/positions/add',
    //修改职位
    apiPositionsEdit: url + '/positions/edit',
    //删除职位
    apiPositionsDel: url + '/positions/del',
    
    //获取职位列表
    apiDepartmentList: url + '/department/list',
    //根据查询条件获取职位列表
    apiDepartmentQueryList: url + '/department/queryList',
    //添加职位
    apiDepartmentAdd: url + '/department/add',
    //修改职位
    apiDepartmentEdit: url + '/department/edit',
    //删除职位
    apiDepartmentDel: url + '/department/del',
    
    //获取设备类型列表
    apiDevicetypeList: url + '/devicetype/list',
    //添加设备类型
    apiDevicetypeAdd: url + '/devicetype/add',
    //修改设备类型
    apiDevicetypeEdit: url + '/devicetype/edit',
    //删除设备类型
    apiDevicetypeDel: url + '/devicetype/del',
    
    //获取业务类型列表
    apiBusinesstypeList: url + '/businesstype/list',
    //添加业务类型
    apiBusinesstypeAdd: url + '/businesstype/add',
    //修改业务类型
    apiBusinesstypeEdit: url + '/businesstype/edit',
    //删除业务类型
    apiBusinesstypeDel: url + '/businesstype/del',
    
    //获取人群种类列表
    apiCrowdtypeList: url + '/crowdtype/list',
    //根据查询条件获取人群种类列表
    apiCrowdtypeQueryList: url + '/crowdtype/queryList',
    //添加人群种类
    apiCrowdtypeAdd: url + '/crowdtype/add',
    //修改人群种类
    apiCrowdtypeEdit: url + '/crowdtype/edit',
    //删除人群种类
    apiCrowdtypeDel: url + '/crowdtype/del',
    
    //获取产品列表
    apiProductList: url + '/product/list',
    //根据查询条件获取产品列表
    apiProductQueryList: url + '/product/queryList',
    //添加产品
    apiProductAdd: url + '/product/add',
    //修改产品
    apiProductEdit: url + '/product/edit',
    //删除产品
    apiProductDel: url + '/product/del',
    
    //价格列表(不分页)
    apiPriceList: url + '/price/list',
    //根据查询条件获取价格列表
    apiPriceQueryList: url + '/price/queryList',
    //添加价格
    apiPriceAdd: url + '/price/add',
    //修改价格
    apiPriceEdit: url + '/price/edit',
    //删除价格
    apiPriceDel: url + '/price/del',
    
    //黑名单列表(不分页)
    apiBlackList: url + '/black_list/list',
    //根据条件查询获取黑名单列表
    apiBlackListQueryList: url + '/black_list/queryList',
    //根据ID 获取黑名单
    apiBlackListQueryById: url + '/black_list/query',
    //添加黑名单
    apiBlackListAdd: url + '/black_list/add',
    //修改黑名单
    apiBlackListEdit: url + '/black_list/edit',
    //删除黑名单
    apiBlackListDel: url + '/black_list/del',


    //获取售票站点列表
    apiTicketstationList: url + '/ticketstation/list',
    //根据查询条件获取售票站点列表
    apiTicketstationQueryList: url + '/ticketstation/queryList',
    //添加售票站点
    apiTicketstationAdd: url + '/ticketstation/add',
    //修改售票站点
    apiTicketstationEdit: url + '/ticketstation/edit',
    //删除售票站点
    apiTicketstationDel: url + '/ticketstation/del',
    
    //获取售票窗口列表
    apiTicketwindowList: url + '/ticketwindow/list',
    //根据查询条件获取售票窗口列表
    apiTicketwindowQueryList: url + '/ticketwindow/queryList',
    //添加售票窗口
    apiTicketwindowAdd: url + '/ticketwindow/add',
    //修改售票窗口
    apiTicketwindowEdit: url + '/ticketwindow/edit',
    //删除售票窗口
    apiTicketwindowDel: url + '/ticketwindow/del',
    
    //根据查询条件获取售票窗口售票权限列表
    apiSalewindowQueryList: url + '/salewindow/queryList',
    //获取售票窗口
    apiSalewindowGetRules: url + '/salewindow/getRules',
    //新增或修改售票窗口销售权限
    apiSalewindowEdit: url + '/salewindow/edit',
    //删除售票窗口销售权限
    apiSalewindowDel: url + '/salewindow/del',
    //获取价格窗口销售权限列表
    apiPriceGetWindowRules: url + '/salewindow/getRulesByPriceId',
    //新增或修改窗口销售权限 by 价格
    apiSalewindowEditByPrice: url + '/salewindow/editRulesByPriceId',

    //获取员工售票权限
    apiSalestaffGetRules: url + '/salestaff/getRules',
    //新增或修改员工销售权限
    apiSalestaffEdit: url + '/salestaff/edit',
    //根据查询条件获取售票员工售票权限列表
    apiSalestaffQueryList: url + '/salestaff/queryList',
    //删除售票窗口销售权限
    apiSalestaffDel: url + '/salestaff/del',

    apiPriceGetStaffRules: url + '/salestaff/getRulesByPriceId',
    //新增或修改员工销售权限 by 价格
    apiSalestaffEditByPrice: url + '/salestaff/editRulesByPriceId',

    //获取价格设备检票权限列表
    apiPriceGetDeviceRules: url + '/sale_device/getRulesByPriceId',
    //新增或修改设备检票权限 by 价格
    apiSaleDeviceEditByPrice: url + '/sale_device/editRulesByPriceId',


    //获取检票园门列表
    apiCheckstationList: url + '/checkstation/list',
    //根据查询条件获取检票园门列表
    apiCheckstationQueryList: url + '/checkstation/queryList',
    //添加检票园门
    apiCheckstationAdd: url + '/checkstation/add',
    //修改检票园门
    apiCheckstationEdit: url + '/checkstation/edit',
    //删除检票园门
    apiCheckstationDel: url + '/checkstation/del',

    //关联检票园门
    apiCheckstationCorrelationQueryList: url + '/checkstationCorrelation/queryList',
    //添加关联检票园门
    apiCheckstationCorrelationAdd: url + '/checkstationCorrelation/add',
    //修改关联检票园门
    apiCheckstationCorrelationEdit: url + '/checkstationCorrelation/edit',  
    //删除关联检票园门
    apiCheckstationCorrelationDel: url + '/checkstationCorrelation/del',


    //获取检票设备列表
    apiCheckDeviceList: url + '/check_device/list',
    //根据查询条件获取检票设备列表
    apiCheckDeviceQueryList: url + '/check_device/queryList',
    //根据MAC查询准进设备列表
    apiCheckDeviceQueryListByMac: url + '/check_device/queryListByMac',
    //添加检票设备
    apiCheckDeviceAdd: url + '/check_device/add',
    //修改检票设备
    apiCheckDeviceEdit: url + '/check_device/edit',
    //删除检票设备
    apiCheckDeviceDel: url + '/check_device/del',

    //根据查询条件获取准进设备权限列表
    apiSaleDeviceQueryList: url + '/sale_device/queryList',
    //获取准进设备
    apiSaleDeviceGetRules: url + '/sale_device/getRules',
    //新增或修改准进设备权限
    apiSaleDeviceEdit: url + '/sale_device/edit',
    //删除准进设备权限
    apiSaleDeviceDel: url + '/sale_device/del',

    apiSaleDeviceDelByIds: url + '/sale_device/del_by_ids',


        
    //获取售票流水列表
    apiOrdersQueryList: url + '/orders/queryList',
    //根据订单号获取订单数据
    apiOrdersQueryByOrderNumber: url + '/orders/getOrdersByOrderNumber',
    //获取检票流水列表
    apiOrdersQueryListByCheck: url + '/orders_log/queryList/check',
	//根据订单编号，获取门票列表
	apiOrderdetailsQueryAll: url + '/orderdetails/queryAll',
    //订单列表
    apiOrderdetailsQueryList: url + '/orderdetails/queryList',
    //订单退款
    apiOrderdetailsRefund: url + '/orderdetails/refund',
    //订单强制退款
    apiOrderdetailsBathRefund: url + '/orderdetails/bath_refund',
    
	
	//获取预制票仓库列表
	apiPflibraryList: url + '/pflibrary/list',
	//根据查询条件获取预制票仓库列表
	apiPflibraryQueryList: url + '/pflibrary/queryList',
	//添加预制票仓库
	apiPflibraryAdd: url + '/pflibrary/add',
	//修改预制票仓库
	apiPflibraryEdit: url + '/pflibrary/edit',
	//删除预制票仓库
	apiPflibraryDel: url + '/pflibrary/del',
	
	//获取预制票票号规则列表
	apiPfruleList: url + '/pfrule/list',
	//根据查询条件获取预制票票号规则列表
	apiPfruleQueryList: url + '/pfrule/queryList',
	//添加预制票票号规则
	apiPfruleAdd: url + '/pfrule/add',
	//修改预制票票号规则
	apiPfruleEdit: url + '/pfrule/edit',
	//删除预制票票号规则
	apiPfruleDel: url + '/pfrule/del',


    //获取预制票详情列表
    apiPfoutDetailsQueryList: url + '/pfoutDetails/queryList',
    //预制票作废
    apiPfoutDetailsCancel: url + '/pfoutDetails/cancel',
    //预制票退回
    apiPfoutDetailsBack: url + '/pfoutDetails/back',
    //预制票导出
    apiPfoutDetailsExport: url + '/pfoutDetails/export',
	
	//根据查询条件获取预制票领用列表
	apiPfoutQueryList: url + '/pfout/queryList',
    //根据查询条件获取预制票列表
    apiPfoutList: url + '/pfout/list',
	//添加预制票入库记录
	apiPfoutAdd: url + '/pfout/check_in',
    //删除预制票入库记录
    apiPfoutDeleteCheckIn: url + '/pfout/delete_check_in',
    //删除预制票领用记录
    apiPfoutDeleteCheckOut: url + '/pfout/delete_check_out',
    //预制票领用
    apiPfoutCheckOut: url + '/pfout/check_out',
	
	//获取预制票票号规则列表
	apiInventoryList: url + '/inventory/list',
	//根据查询条件获取库存设置
	apiInventoryQueryList: url + '/inventory/queryList',
	//添加库存设置
	apiInventoryAdd: url + '/inventory/add',
	//修改库存设置
	apiInventoryEdit: url + '/inventory/edit',
	
	//根据查询条件获取库存详情
	apiInventoryDetailsQueryList: url + '/inventoryDetails/queryList',
	//修改库存详情
	apiInventoryDetailsEdit: url + '/inventoryDetails/edit',
	
	//上传文件
	apiUploadFiles: url + '/uploadFiles/up',
	
	//获取栏目列表
	apiColumnList: url + '/column/list',
	//根据查询条件获取栏目列表
	apiColumnQueryList: url + '/column/queryList',
	//添加栏目
	apiColumnAdd: url + '/column/add',
	//修改栏目
	apiColumnEdit: url + '/column/edit',
	//删除栏目
	apiColumnDel: url + '/column/del',
	
	//获取文章列表
	apiArticleList: url + '/article/list',
	//根据查询条件获取文章列表
	apiArticleQueryList: url + '/article/queryList',
	//添加文章
	apiArticleAdd: url + '/article/add',
	//修改文章
	apiArticleEdit: url + '/article/edit',
	//删除文章
	apiArticleDel: url + '/article/del',
	
	//获取轮播图列表
	apiBannerList: url + '/banner/list',
	//根据查询条件获取轮播图列表
	apiBannerQueryList: url + '/banner/queryList',
	//添加轮播图
	apiBannerAdd: url + '/banner/add',
	//修改轮播图
	apiBannerEdit: url + '/banner/edit',
	//删除轮播图
	apiBannerDel: url + '/banner/del',

    //推广团队列表
    apiPromotionTeamList: url + '/promotion_team/list',
	//根据查询条件获取推广团队列表
	apiPromotionTeamQueryList: url + '/promotion_team/queryList',
	//添加推广团队
	apiPromotionTeamAdd: url + '/promotion_team/add',
	//修改推广团队
	apiPromotionTeamEdit: url + '/promotion_team/edit',
	//删除推广团队
	apiPromotionTeamDel: url + '/promotion_team/del',

    //推广海报列表
    apiPromotionPosterList: url + '/promotion_poster/list',
	//根据查询条件获取推广海报列表
	apiPromotionPosterQueryList: url + '/promotion_poster/queryList',
	//添加推广海报
	apiPromotionPosterAdd: url + '/promotion_poster/add',
	//修改推广海报
	apiPromotionPosterEdit: url + '/promotion_poster/edit',
	//删除推广海报
	apiPromotionPosterDel: url + '/promotion_poster/del',
	
    //推广用户列表
    apiPromotionUserList: url + '/tourist/list',
	//根据查询条件获取推广用户列表
	apiPromotionUserQueryList: url + '/tourist/queryList',
	//添加推广用户
	apiPromotionUserAdd: url + '/tourist/add',
	//修改推广用户
	apiPromotionUserEdit: url + '/tourist/edit',
	//删除推广用户
	apiPromotionUserDel: url + '/tourist/del',
	
	//表单模板相关接口
	//保存表单模板
	apiFormTemplateAdd: url + '/formTemplate/add',
	//修改表单模板
	apiFormTemplateEdit: url + '/formTemplate/edit',
	//获取表单模板列表
	apiFormTemplateList: url + '/formTemplate/list',
	//根据查询条件获取表单模板列表
	apiFormTemplateQueryList: url + '/formTemplate/queryList',
	//删除表单模板
	apiFormTemplateDel: url + '/formTemplate/del',
	
	//会员相关接口
	//获取会员列表表头配置
	apiMemberColumns: url + '/member/columns',
	//根据查询条件获取会员列表
	apiMemberQueryList: url + '/member/queryList',
	//获取会员列表
	apiMemberList: url + '/member/list',
	//编辑会员信息
	apiMemberEdit: url + '/member/edit',

    //获取打印模板列表
    apiPrintTemplateList: url + '/print/template/list',
    //根据查询条件获取打印模板列表
    apiPrintTemplateQueryList: url + '/print/template/queryList',
    //添加打印模板
    apiPrintTemplateAdd: url + '/print/template/add',
    //修改打印模板
    apiPrintTemplateEdit: url + '/print/template/edit',
    //删除打印模板
    apiPrintTemplateDel: url + '/print/template/del',
    //获取打印模板参数
    apiPrintTemplateParams: url + '/print/param/list',

    //员工卡列表
    apiStaffCardQueryList: url + '/staff_card/queryList',
    //添加员工卡
    apiStaffCardAdd: url + '/staff_card/add',
    //修改员工卡
    apiStaffCardEdit: url + '/staff_card/edit',
     //删除员工卡
     apiStaffCardDel: url + '/staff_card/del',

     //员工卡使用记录
     apiStaffCardLogQueryList: url + '/staff_card_log/queryList',

     //零售商品列表
     apiProductMallQueryList: url + '/product_mall/queryList',
     //添加零售商品
     apiProductMallAdd: url + '/product_mall/add',
     //修改零售商品
     apiProductMallEdit: url + '/product_mall/edit',
     //删除零售商品
     apiProductMallDel: url + '/product_mall/del',
     //获取零售商品详情
     apiProductMallDetail: url + '/product_mall/detail',


     //销售统计
     apiSaleStatistics: url + '/report/saleStatistics',
     //检票统计
     apiTicketStatistics: url + '/report/ticketStatistics',
     //售票员销售报表
     apiStaffStatistics: url + '/report/staffStatistics',
     //商品销售报表
     apiProductStatistics: url + '/report/productStatistics',

     //计费规则
     apiPriceEditBillingRule: url + '/price/editBillingRule',
     //获取计费规则
     apiGetBillingRuleByPriceId: url + '/price/getBillingRuleByPriceId',
     //获取价格配置
     apiPriceConfig: url + '/price/config/info',
     //修改价格配置
     apiPricePrintTemplate: url + '/price/config/print_template',
     //确认优惠政策
     apiPriceDiscountConfirm: url + '/price/config/discount_confirm',



     //批量添加日价格
     apiPriceBatchAddPriceDay: url + '/price/day/batchAddPriceDay',
     //批量修改日价格
     apiPriceBatchEditPriceDay: url + '/price/day/batchEditPriceDay',
     //根据查询条件获取日价格列表
     apiPriceDayQueryList: url + '/price/day/queryList',
     //根据查询条件获取日价格列表
     apiPriceDayDetails: url + '/price/day/detail',
     //修改日价格
     apiPriceDayEdit: url + '/price/day/edit',


     //获取优惠政策列表
     apiPriceDiscountList: url + '/price_discount/list',
     //根据查询条件获取优惠政策列表
     apiPriceDiscountQueryList: url + '/price_discount/queryList',
     //添加优惠政策
     apiPriceDiscountAdd: url + '/price_discount/add',
     //修改优惠政策
     apiPriceDiscountEdit: url + '/price_discount/edit',
     //删除优惠政策
     apiPriceDiscountDel: url + '/price_discount/del',

     //获取优惠政策详情
     apiPriceDiscountDetailsList: url + '/price_discount_details/list',
     //添加优惠政策详情
     apiPriceDiscountDetailsAdd: url + '/price_discount_details/add',
     //修改优惠政策详情
     apiPriceDiscountDetailsEdit: url + '/price_discount_details/edit',
     //删除优惠政策详情
     apiPriceDiscountDetailsDel: url + '/price_discount_details/del',


     //登录日志
     apiLoginLogQueryList: url + '/login_log/queryList',

     //操作日志
     apiOperationLogQueryList: url + '/operation_log/queryList',

	
}